<td>
  <span class="flex gap-2 align-items-center">
    @if (item.icon) {
      <app-svg-icon [key]="item.icon" />
    } @else {
      <i class="fa-regular fa-map"></i>
    }
    {{ item.name }}
  </span>
</td>
<td>
  <span class="flex gap-2">
    @if (actions.includes('generateView')) {
      <p-button
        pTooltip="Im Atlas anzeigen"
        styleClass="p-button-xs"
        (click)="generateView(item)"
        [rounded]="true"
        icon="fas fa-eye"></p-button>
    }
    @if (actions.includes('select')) {
      <p-button
        styleClass="p-button-xs"
        (click)="select(item)"
        [rounded]="true"
        icon="fas fa-hand-pointer"></p-button>
    }
    @if (actions.includes('edit')) {
      <a
        pButton
        class="p-button-xs"
        (click)="closeParent()"
        [routerLink]="[{ outlets: { bearbeiten: ['raum', item._id] } }]"
        [rounded]="true"
        icon="fas fa-pen"></a>
    }
  </span>
</td>
